import {
  AZURE_UPLOAD_START,
  AZURE_UPLOAD_SUCCESS,
  AZURE_UPLOAD_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  data: [],
};

export default function azureUploadReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case AZURE_UPLOAD_START:
      return {
        ...state,
        loading: true,
      };
    case AZURE_UPLOAD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case AZURE_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
